import Rails from '@rails/ujs';

let logTimer;

export default function logs(text, empty) {
  clearTimeout(logTimer);

  logTimer = setTimeout(function(){
    if ($.trim($("#search_key").val().toLowerCase()) !== text) return;

    $.ajax({
      url: "/en/search_log",
      type: 'post',
      data: {text: text, empty: empty},
      headers: {
        'X-CSRF-Token': Rails.csrfToken()
      },
      credentials: 'same-origin'
    });
  }, 1000);
}
